import React, { useState, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import { apiHolder as api, apis, inWindow } from 'api';
import PersonPraiseMedal from '@web-mail/components/PersonPraiseMedal';
import styles from './detail.module.scss';
import { ReactComponent as IconArrowRight } from '@/images/icons/arrow-right.svg';
import { getIn18Text } from 'api';
const mailPraiseApi = api.api.requireLogicalApi(apis.mailPraiseApiImpl);
const systemApi = api.api.getSystemApi();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const MedalInfo = props => {
    var _a, _b;
    const { from, contact } = props;
    const [personMedalData, setPersonMedalData] = useState(null);
    const [showMedalData, setShowMedalData] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [toIndex, setToIndex] = useState(0);
    const accountId = contact === null || contact === void 0 ? void 0 : contact.contact.id;
    const isEnLang = inWindow() && window.systemLang === 'en';
    const wordSeparator = isEnLang ? ' ' : '';
    useEffect(() => {
        if (accountId) {
            (async () => {
                const response = await mailPraiseApi.getPersonMedalDetail(accountId);
                if (response.data) {
                    setPersonMedalData(response.data.medals);
                }
                else {
                    setPersonMedalData(null);
                }
            })();
        }
    }, [accountId]);
    useEffect(() => {
        if (personMedalData) {
            setShowMedalData(personMedalData.slice(0, from === 'contact' ? 6 : 5));
        }
    }, [personMedalData]);
    const allCounts = useCallback(() => {
        return personMedalData === null || personMedalData === void 0 ? void 0 : personMedalData.reduce((pre, cur) => {
            return pre + cur.count;
        }, 0);
    }, [personMedalData]);
    const goToPersonMedal = (index = 0) => {
        setToIndex(index);
        setModalVisible(true);
        trackApi.track('pcContact_click_contactsDetailPage_seeTheMedal');
    };
    const handleCancel = () => {
        setModalVisible(false);
    };
    const praiseOwner = ((_b = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.contact) === null || _b === void 0 ? void 0 : _b.contact.id) === accountId;
    const xunZhangCountTxt = isEnLang ? `${allCounts()} ${getIn18Text('XUNZHANG')}` : `${getIn18Text('XUNZHANG')}${allCounts()}${getIn18Text('MEI')}`;
    if (showMedalData) {
        return (React.createElement("div", { className: classnames(styles.detailMedalContainer, { [styles.detailMedalOtherContainer]: from !== 'contact' }) },
            React.createElement("div", { className: styles.medalInfoWrap },
                from === 'contact' ? React.createElement("div", { className: styles.medalInfo }, getIn18Text('XUNZHANG')) : null,
                React.createElement("div", { className: styles.medalList }, showMedalData
                    ? showMedalData.map((medal, index) => {
                        return (React.createElement("div", { className: styles.medalItem, key: medal.id, onClick: () => {
                                goToPersonMedal(index);
                            } },
                            React.createElement("img", { src: medal.count > 0 ? medal.imageUrl : medal.grayImageUrl, alt: "" })));
                    })
                    : null)),
            React.createElement("div", { className: styles.countInfo, onClick: () => {
                    goToPersonMedal();
                } },
                xunZhangCountTxt,
                React.createElement(IconArrowRight, null)),
            personMedalData && modalVisible && (React.createElement(PersonPraiseMedal, Object.assign({}, {
                personMedalData,
                isModalVisible: modalVisible,
                from,
                toIndex,
                handleCancel,
                praiseOwner,
            })))));
    }
    return null;
};
export default MedalInfo;
